import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WhiteWrapper, TabWrapper } from './indicator.styled'
import { Radio, Select, Button } from 'antd'
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons'
import useParams from '../../hook/useParams'
import { useSelector } from 'react-redux'
import { fetchBrandList } from '../../apis/brand'
import Dimension from './Dimension'
import IndicatorSetting from './Indicator'

function Indicator (props) {
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const { nowGroup } = user || {}
  const params = useParams({ 'brandId!': 0, groupId: nowGroup })
  const { fetchParams, handleFetchParams } = params
  const [tab, setTab] = useState('dimension')
  const [brands, setBrands] = useState([])
  const [modalData, setModalData] = useState({ open: false })
  const brandMapping = brands?.reduce((all, i) => ({ ...all, [i.value]: i.label }), {})

  const menu = [
    { value: 'dimension', label: ln_t('indicator.dimensionSetting') },
    { value: 'indicator', label: ln_t('indicator.indicatorSetting') }
  ]
  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`indicator.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({
    name, label: ln_t(`indicator.${name}`), rules: [{ required, message: defPlaceholder(name, type) }]
  })

  const handleChangeTab = e => {
    setTab(e.target.value)
    handleFetchParams('init', { brandId: fetchParams?.brandId })
  }

  const getBrands = async () => {
    const res = await fetchBrandList({ maxResults: 999, groupId: nowGroup })
    if (res?.status === 200) setBrands(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }

  useEffect(() => { getBrands() }, [nowGroup])

  const passProps = { params, defConfig, defPlaceholder, brands, brandMapping, modalData, setModalData }
  return <WhiteWrapper>
    <h3>{ln_t('sidebar.indicatorSetting')}</h3>

    <TabWrapper>
      <Radio.Group
        buttonStyle="solid"
        value={tab}
        onChange={handleChangeTab}
        options={menu}
        optionType="button"
      />
      <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: 500 }}>{ln_t('util.brand')} :</div>
      <Select
        value={fetchParams?.brandId || 'ALL'}
        options={[{ value: 'ALL', label: 'ALL' }, ...brands]}
        onChange={e => handleFetchParams('add', { brandId: e === 'ALL' ? undefined : e })}
        style={{ minWidth: '120px' }}
      />
      {tab === 'indicator' && fetchParams?.brandId &&
        <Button icon={<DownloadOutlined />} style={{ marginLeft: 'auto' }} onClick={() => setModalData({ open: true, type: 'download', data: { brandId: fetchParams?.brandId } })}>
          {ln_t('indicator.downloadAll')}
        </Button>}
      <Button icon={<PlusOutlined />} style={{ marginLeft: tab === 'indicator' && fetchParams?.brandId ? 0 : 'auto' }} onClick={() => setModalData({ open: true, type: 'create', data: { brandId: fetchParams?.brandId } })}>
        {ln_t('util.add')} {ln_t(`indicator.${tab}`)}
      </Button>
    </TabWrapper>

    {tab === 'dimension' ? <Dimension {...passProps} /> : <IndicatorSetting {...passProps} />}
  </WhiteWrapper>
}

export default Indicator
